import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="autosubmit-form"
export default class extends Controller {
  static targets = ['form']

  declare readonly formTarget: HTMLFormElement

  submitForm () {
    this.formTarget.submit()
  }
}
